import React, { useState, useEffect, useCallback } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Shield, Gift, Users, Crown } from 'lucide-react';

const SLIDES = [
  { id: 0, bg: 'from-[#1f2d5a] to-[#2a3f7a]', icon: Shield, title: 'Seguro de protección', desc: 'Tu capitalización siempre resguardada e indexada' },
  { id: 1, bg: 'from-[#fbb040] to-[#e09a20]', icon: Gift, title: 'Cashback del 2%', desc: 'Recibe recompensas por tus aportes puntuales', dark: true },
  { id: 2, bg: 'from-[#16a34a] to-[#15803d]', icon: Users, title: 'Invita y gana', desc: 'Gana bonificaciones por cada Kompa referido' },
  { id: 3, bg: 'from-[#fbb040] to-[#d4900e]', icon: Crown, title: 'Kompa Club Premium', desc: 'Edita tus metas, prioridad en grupos y más', dark: true, notranslate: true },
];

export default function PromoBanner() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent(prev => (prev + 1) % SLIDES.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 4000);
    return () => clearInterval(timer);
  }, [next]);

  const slide = SLIDES[current];
  const Icon = slide.icon;
  const textColor = slide.dark ? 'text-black' : 'text-white';
  const textMuted = slide.dark ? 'text-black/70' : 'text-white/80';

  return (
    <div className="px-6 md:px-8 pb-3" data-testid="promo-banner">
      <div className="relative overflow-hidden rounded-2xl h-[72px]">
        <AnimatePresence mode="wait">
          <motion.div
            key={slide.id}
            initial={{ opacity: 0, x: 40 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: -40 }}
            transition={{ duration: 0.35 }}
            className={`absolute inset-0 bg-gradient-to-r ${slide.bg} flex items-center px-5 gap-3`}
          >
            <div className={`w-10 h-10 rounded-xl flex items-center justify-center flex-shrink-0 ${slide.dark ? 'bg-black/10' : 'bg-white/15'}`}>
              <Icon className={`w-5 h-5 ${textColor}`} />
            </div>
            <div className="min-w-0">
              <p
                className={`text-sm font-bold ${textColor} truncate`}
                {...(slide.notranslate ? { translate: 'no' } : {})}
              >
                {slide.title}
              </p>
              <p className={`text-xs ${textMuted} font-light truncate`}>{slide.desc}</p>
            </div>
          </motion.div>
        </AnimatePresence>
        {/* Dots */}
        <div className="absolute bottom-2 right-4 flex gap-1">
          {SLIDES.map((_, i) => (
            <button
              key={i}
              onClick={() => setCurrent(i)}
              className={`w-1.5 h-1.5 rounded-full transition-all ${i === current ? 'bg-white w-4' : 'bg-white/40'}`}
              data-testid={`promo-dot-${i}`}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
